import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InstrumentModelComponent} from './instrument-model.component';
import {MatButtonModule} from '@angular/material/button';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {TranslateModule} from '@ngx-translate/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSelectModule} from '@angular/material/select';
import {FlexModule} from '@angular/flex-layout';
import {FuseDirectivesModule} from '../../../@fuse/directives/directives';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatToolbarModule} from '@angular/material/toolbar';
import {DialogModule} from '../../confirmation/dialog.module';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {ModelSelectionDialogComponent} from './model-selection-dialog/model-selection-dialog.component';


@NgModule({
    declarations: [
        InstrumentModelComponent,
        ModelSelectionDialogComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatExpansionModule,
        MatIconModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        TranslateModule,
        MatTooltipModule,
        MatDialogModule,
        MatSelectModule,
        FlexModule,
        FuseDirectivesModule,
        MatCheckboxModule,
        MatToolbarModule,
        DialogModule,
        MatAutocompleteModule
    ],
    exports: [
        InstrumentModelComponent,
        ModelSelectionDialogComponent
    ]
})

export class InstrumentModelModule { }
